
var wFlag = window.innerWidth>750

function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(()=>{

    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=10%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    showUp('.box4_title')
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top center-=10%',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box4_text',{opacity:0})
            // .from('.box4_text img',{opacity:0,y:'2rem'})
    })

    showUp('.box5_item')

    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5_1',
        start:wFlag?'top top+=6%':'top top+=2%',
        end:'+=80%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to({},{duration:0.2})
            .from('.box5_info .box5_item1:nth-child(2)',{opacity:0,y:'5rem'})
            .to('.box5_info .box5_item1:nth-child(1)',{opacity:0},'<')
            // .to({},{duration:0.5})
            // .call(playVideoOnce)
            // .from('.box5_info .box5_item1:nth-child(3)',{opacity:0,y:'5rem'})
            // .to('.box5_info .box5_item1:nth-child(2)',{opacity:0},'<')
            .to({},{duration:0.2})
    })

    const video = document.querySelector('.box5_info video');
    let videoPlaying = false;
    function playVideoOnce() {

        // 正在播放，直接退出
        if (!video || videoPlaying) return;
        videoPlaying = true;

        video.play().catch(err => {
            videoPlaying = false;
            console.warn('Video playback failed:', err);
        });
    }
    //playVideoOnce()
    if (video) {
        video.addEventListener('ended', () => {videoPlaying = false;});
    }

    //box6
    var nexlimN1 = 10,ng_flag=true,flag_ng;
    function startNG(){
        clearInterval(flag_ng); // 防止重复开启多个定时器
        flag_ng =  setInterval(num,20)
    }
    function num(){
        nexlimN1++;
        if (nexlimN1 >= 80) {
            nexlimN1 = 80;
            clearInterval(flag_ng);
        }
    
        $(`.box6_title p c:nth-child(1)`).text(`${nexlimN1}`);
    }

    ScrollTrigger.create({
        trigger:'.box6', 
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag){
                    startNG()
                    ng_flag=false;
                }
            }
            if(index<2){
                // 重置
                ng_flag=true,nexlimN1 = 10
            }
        }
    })
    
    //box_text1
    ScrollTrigger.create({
        trigger:'.box_text1',
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box_text1 span',{opacity:0})
            .from('.box_text1 img',{opacity:0,y:'2rem'})
    })

    //box11
    showUp('.box11_title')
    ScrollTrigger.create({
        trigger:'.box11',
        start:'top+=10% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box11_icon',{opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box11',
        start:'top+=40% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box11_1',{x:'100%'})
            .call(box11Video)
    })
    ScrollTrigger.create({
        trigger:'.box11',
        start:'top top+=4%',
        end:'+=100%',
        pin:true
    })

    var box11Flag = false
    function box11Video(){
        if(box11Flag) return;
        box11Flag = true
        $('.box11_1 video')[0].play()
    }
    $('.box11_1 video').on('ended', function () {
        box11Flag = false;
    });
    
    //box_text2
    ScrollTrigger.create({
        trigger:'.box_text2',
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box_text2 span',{opacity:0})
            .from('.box_text2 img',{opacity:0,y:'2rem'})
    })

    //box12
    gsap.fromTo( '.box12_img img:last-child',{ opacity: 0 },{opacity: 1,duration: 1,repeat: -1,yoyo: true,ease: 'none'});

    var nexlimN2 = 40,ng_flag1=true,flag_ng2;
    function startNG2(){
        clearInterval(flag_ng2); // 防止重复开启多个定时器
        flag_ng2 =  setInterval(num2,20)
    }
    function num2(){
        nexlimN2++;
        if (nexlimN2 >= 100) {
            nexlimN2 = 100;
            clearInterval(flag_ng2);
        }
    
        $(`.box12_num d`).text(`${nexlimN2}`);
    }

    ScrollTrigger.create({
        trigger:'.box12', 
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag1){
                    startNG2()
                    ng_flag1=false;
                }
            }
            if(index<2){
                // 重置
                ng_flag1=true,nexlimN2 = 40
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box12',
        start:wFlag?'top+=15% top+=14%':'top+=15% top+=4%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to({},{duration:0.4})
            .to('.box12_img',{opacity:0})
            .from('.box12_mask',{x:'105%'},'<')
            .to('.box12_text span:first-child',{opacity:0},'<')
            .from('.box12_text span:last-child',{opacity:0,y:'2rem'},'<')
    })
    ScrollTrigger.create({
        trigger:'.box12',
        start:wFlag?'top top+=14%':'top top+=4%',
        end:'+=50%',
        pin:true
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger: '.box3',
            start:'top+=20% top+=4%',
            end: '+=0%',
            toggleActions: 'play none none reverse',
            animation: gsap.timeline()
                .to('.box3_video', { x:'48%' })
                .from('.box3_title', { opacity:0,y:'2rem' })
        })

        ScrollTrigger.create({
            trigger: '.box3',
            start:'top top+=4%',
            end: '+=50%',
            pin:true,
            anticipatePin: 1,
        })
    }else{
        showUp('.box3_title')
    }
})